import { createFileRoute } from '@tanstack/react-router'
import { Sustainability } from '../../pages'

export const Route = createFileRoute('/_layout/sustainability')({
    component: Sustainability,
})
